import React from "react";
import ReactDOM from "react-dom";
import App from "./app"

ReactDOM.render(
    <App/>,
    document.getElementById("main")
);


// WEBPACK FOOTER //
// ./src/index.jsx